<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.search.sync_status" placeholder="成本同步状态">
                    <el-option :value="1" label="未同步"></el-option>
                    <el-option :value="2" label="已同步"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.processing_no" placeholder="加工单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.search.batch_no" placeholder="批次号" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                    <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList()">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batchEdit">批量修改</el-button> -->
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="sync">同步成本</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="processing.costing.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @getTableEdit="edit" @getTableDelete="del"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="processing.costing.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag title="修改" :visible.sync="editDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="editForm" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <!-- <el-form-item label="发票抬头：">
                        <el-select v-model="editForm.type">
                            <el-option label="发票金额" :value="1"></el-option>
                            <el-option label="其他费用" :value="2"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="发票金额：">
                        <el-input v-model="editForm.invoice_amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="其他费用金额：">
                        <el-input v-model="editForm.other_amount" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="editDialog=!editDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="confirmEdit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:18px; font-weight:bold; line-height:25px; color: #333333;padding-bottom:20px;}
</style>
<script>
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                isShowMore:false,
                start_time:"",
                end_time:"",
                module:localStorage.dw_erp_power_code,
                editDialog:false,
                editForm:{
                    id:"",
                    type:"",
                    invoice_amount:"",
                    other_amount:""
                },
                selectList:[],
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        processing_no:"",
                        batch_no:"",
                        contract_no:"",
                        sync_status:""
                    },
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2单条，3多条
                list : [],
                selectDialogVisible:false,
                // dialog START
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[
                    {colName:"同步状态",colKey:"sync_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工日期",colKey:"processing_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工单号",colKey:"processing_no",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isArray:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"原木方数",colKey:"start_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"原木采购单价",colKey:"price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"加工成品方数",colKey:"end_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"板材核算单价",colKey:"cube_price",colWidth:130,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总加工费金额",colKey:"processing_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"三角料金额",colKey:"triangle_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"扣除发票金额",colKey:"invoice_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"其它费用金额",colKey:"other_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用平摊单价",colKey:"cost_price",colWidth:130,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                // dialog END
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            sync(){
                let flag = true;
                if(this.selectList.length>0){
                    let ids = [];
                    this.selectList.forEach(item=>{
                        if(!item.isEdit){
                            flag = false;
                            this.tip("选中内容有不可同步项","warning")
                        }else{
                            ids.push(item.id)
                        }
                    })
                    if(flag){
                        this.$confirm('是否确认同步?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFuncLoading("/erp/processing.sync",{ids:ids},()=>{
                                this.tip("同步成功","success")
                                this.getList()
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }
                }else{
                    this.tip("请选择内容","warning")
                }
            },
            confirmEdit(){
                if(this.updataType==3){
                    let ids = [];
                    this.selectList.forEach(item=>{
                        ids.push(item.id)
                    })
                    this.editForm.id = ids;
                }
                this.postFuncLoading("/erp/processing.field",this.editForm,()=>{
                    this.tip("修改成功","success")
                    this.editDialog = false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            batchEdit(){
                let flag = true;
                if(this.selectList.length>0){
                    this.selectList.forEach(item=>{
                        if(!item.isEdit){
                            flag = false;
                            this.tip("选中内容有不可修改项","warning")
                        }
                    })
                    if(flag){
                        this.updataType=3;
                        this.editDialog=true;
                    }
                }else{
                    this.tip("请选择内容","warning")
                }
            },
            filterConfirm(){
                this.getList()
            },
            reset(){
                this.params={search:{start_time:"",end_time:"",processing_no:"",batch_no:"",contract_no:"",sync_status:""},per_page: 50,page:1}
                this.start_time = "";
                this.end_time = "";
                this.getList()
            },
            selectChange(row){
                this.selectList=row;
            },
            del(id){
                this.pl(id)
            },
            edit(id){
                this.editDialog=true;
                this.updataType=2;
                this.list.forEach(item=>{
                    if(item.id==id){
                        let editForm=JSON.parse(JSON.stringify(item));
                        this.editForm = editForm;
                        this.editForm.id = item.id;
                    }
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time = this.formatTimeZero(this.start_time)
                this.params.search.end_time = this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.costing.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach((item)=>{
                        // if(item.is_sync){
                        //     item.status_text = "已同步";
                        // }else{
                        //     item.status_text = "未同步";
                        // }
                        item.isEdit = true;
                        // item.width_total = this.keepLimit(item.width_total)
                        // item.cube = this.keepLimit(item.cube)
                        item.processing_time = this.formatTime(item.processing_time*1000)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            }
        },
         watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "editDialog":function(val){
                if(!val){
                    this.editForm = this.resetJson(this.editForm)
                }
            }
        }
    }
</script>
